import Partner from ".";

export const partnerRoutes = [
  {
    path: "/partner",
    element: <Partner />,
  },
];
